const enum AccessIssue {
    ReadOnly,
    ReadOnlyPlusAttachmentsBlocked,
    None,
}
export default AccessIssue;

export const AccessIssues = [AccessIssue.ReadOnly, AccessIssue.ReadOnlyPlusAttachmentsBlocked];
